// src/encounter/intelligence/ask-answer.ts
//
// How an Ask answer is drawn, as data: the engine's answer is markdown-like text whose citations are record ids in
// square brackets ("[obs:record:lab:2026-09-16:hba1c]"). Each line becomes a block; each citation stays attached to the
// line it supports (never dropped, never rendered as text the clinician could mistake for prose). Pure, tested.

export interface AnswerBlock { kind: 'heading' | 'item' | 'text'; text: string; cites: string[] }

const CITE = /\[((?:obs|gap|state|prb|med|doc|study|src|ser|fact):[^\]\s]{1,160})\]/g;

export function answerBlocks(answer: string): AnswerBlock[] {
  const out: AnswerBlock[] = [];
  for (const raw of answer.split('\n')) {
    const cites = [...raw.matchAll(CITE)].map((m) => m[1]);
    let text = raw.replace(CITE, '').replace(/\*\*|__|`/g, '').replace(/\s+([.,;:])/g, '$1').trim();
    if (!text) continue;
    let kind: AnswerBlock['kind'] = 'text';
    if (/^#{1,6}\s+/.test(text)) { kind = 'heading'; text = text.replace(/^#{1,6}\s+/, ''); }
    else if (/^([-*•]|\d+\.)\s+/.test(text)) { kind = 'item'; text = text.replace(/^([-*•]|\d+\.)\s+/, ''); }
    else if (/^\|.*\|$/.test(text)) { if (/^\|[\s:|-]+\|$/.test(text)) continue; kind = 'item'; text = text.replace(/^\||\|$/g, '').split('|').map((c) => c.trim()).filter(Boolean).join(' · '); }
    out.push({ kind, text, cites });
  }
  return out;
}
